import { useNavigate } from "react-router-dom";
import { TableItemId } from "../../../../components/tables/TableWidget";
import {
  crudRoutes,
  receptionRoutes,
} from "../../../../router/routesConstants";
import { setProductWithCustomBc } from "../../../../redux/reducer/receipt.reducer";
import { useAppDispatch } from "../../../../redux/hooks";
import { ProductsWithCustomSnListInterface } from "../../../../redux/interfaces/receipt.interface";
import ActionMenu from "../../../../components/actionMenu/ActionMenu";

function ProductsWithoutSnActionButtons({
  itemId,
  crudData,
}: {
  itemId: TableItemId;
  crudData: ProductsWithCustomSnListInterface;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const createProduct = () => {
    dispatch(setProductWithCustomBc(crudData));

    navigate(
      `/${receptionRoutes.productsWithCustomBc}/${receptionRoutes.productsWithoutSn}/${itemId}/${crudRoutes.create}`,
    );
  };

  return (
    <ActionMenu
      minItemsForMenu={2}
      title={crudData.numeProdus}
      ariaLabel={`Actiuni pentru produsul ${crudData.numeProdus}`}
      items={[
        {
          id: "add",
          label: "Adauga",
          icon: "ADD",
          tooltip:
            "Deschide crearea codului de bare personalizat pentru acest produs.",
          onClick: createProduct,
        },
      ]}
    />
  );
}

export default ProductsWithoutSnActionButtons;
